import DateFnsUtils from "@date-io/date-fns";

export const validateDate = date => {
  if (!date) return true;

  const parsedDate = new Date(date);
  const today = new Date();
  parsedDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return parsedDate <= today && !isNaN(parsedDate);
}

export const getFormattedDate = date => {
  if (!date) {
    return null;
  }
  const parsedDate = new Date(date);

  let utils = new DateFnsUtils();
  return utils.format(parsedDate, "yyyy-MM-dd");
}